
import React from "react";
import { cn } from "@/lib/utils";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "accent";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  children: React.ReactNode;
}

const Button = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className,
  children,
  ...props
}: ButtonProps) => {
  const baseClasses = "doodle-button transition-all duration-150";
  
  const variantClasses = {
    primary: "bg-main-green hover:bg-main-green/90",
    secondary: "bg-light-yellow hover:bg-light-yellow/90",
    accent: "bg-soft-pink hover:bg-soft-pink/90",
  };
  
  const sizeClasses = {
    sm: "text-sm px-3 py-1.5 rounded-lg",
    md: "text-base px-6 py-3 rounded-xl",
    lg: "text-lg px-8 py-4 rounded-xl",
  };
  
  const widthClass = fullWidth ? "w-full" : "";
  
  return (
    <button
      className={cn(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        widthClass,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
